<template>
    <div class="loginbg" style="display: none;">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form id="loginCustomerForm">
                            <!-- <div class="form-group">
                                <label for="inputEmail1">Username</label>
                                <input id="inputEmail1" name="loginFormData.username" v-model="loginFormData.username" type="email" placeholder="Username" v-validate="'required|email'" class="form-control">
                                <small v-if="error.username" class="has-text-danger">{{ error.email[0] }}</small>
                                <span class="help is-danger" v-if="errors.first('loginFormData.username')" v-show="loginFormData.username != ''"><span class="color-c3202b float-l width-full font-text-regular-san">Username must be a valid email</span></span>
                                <span class="help is-danger" v-if="errors.has('loginFormData.username')" v-show="loginFormData.username == ''"><span class="color-c3202b float-l width-full font-text-regular-san">Username is required</span></span>
                            </div>

                            <div class="form-group">
                                <label for="inputPassword1">Password</label>
                                <input id="inputPassword1" name="loginFormData.password" v-model="loginFormData.password" type="password" placeholder="Password" v-validate="'required'" class="form-control">
                                <small v-if="error.password" class="has-text-danger">{{ error.password[0] }}</small>
                                <span v-show="errors.has('loginFormData.password')" v-if="errors.has('loginFormData.password')" class="help is-danger"><span class="color-c3202b float-l width-full font-text-regular-san">Password is required</span></span>
                            </div>
                            
                            <p v-if="fronterrors.length > 0">
                                <ui>
                                    <li v-for="fronterror in fronterrors" :key="fronterror.id"  style="text-align: center"><span class="color-c3202b float-l width-full font-text-regular-san">{{fronterror}}</span></li>
                                </ui>
                            </p>
                            <span class="color-c3202b float-l width-full font-text-regular-san" style="display : none;" id="errorMsg"></span>
                            <div>
                                <button id="loginbtn" type="submit" class="btn general-button btn-primary" v-on:click.prevent="attemptLogin()" >Login</button>
                                <router-link href="javascript:void(0)" v-bind:to="'/forgotpassword'">Forgot password?</router-link>
                            </div> -->
                            <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    Logout from (<a v-bind:href="ssoDomainUrl">{{ssoDomainUrl}}</a>),If You are not able to login please clear Cookies and login again.
                                    Please contact admin if you are still not able to Login.
                            </label>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import EventBus from './event-bus';
    import {loginUrl, configs, getuserUrl} from '../config';
    import VeeValidate from "vee-validate";
    Vue.use(VeeValidate);
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common.js';

    //import Autocomplete from 'vuejs-auto-complete'
    export default {
        name: 'Login',
        mixins: [SessioMixin],
        props: [''],
        components: {
        },
        data() {
            return {
                username: "",
                password: "",
                not_registered_url: "",
                forgot_pass_url: "",
                username_error_msg: "",
                password_error_msg: "",

                forgot_pass_url: "",
                buttonNames : {
                    loginButton : 'Login',
                },

                disableButtons : {
                    loginButton : false,
                },

                error: {},
                fronterrors: [],

            }
        },
        beforeMount: function () {
            self = this;
            self.ssoDomainUrl = process.env.SSO_ROOT_URL;

            if(self.$route.query.redirect == "false") {
                // DO NOTHING
            } else {
                if(self.$route.query.token) {
                    window.localStorage.setItem("api_token", self.$route.query.token);
                    window.localStorage.setItem("username", self.$route.query.username);
                    self.autoLoginUser(self.$route.query.username);
                } else {
                    var api_token = localStorage.getItem("api_token");
                    if(api_token == null) {
                        $(".loginbg").show();
                        window.location.href = process.env.SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                    } else {
                        window.location.href = "/listcustomer";
                    }
                }
            }
        },
        mounted: function () {
            // $('.navbar').hide();
            // $('.footer-main').hide();
            // if(window.location.pathname == "/login") {
            //     $(".app-sidebar-right").css("padding-left","0px");
            //     $(".app-sidebar-right").css("margin-top","0px");
            //     $(".app-sidebar-right").css({"-webkit-transition":"all 0.0s ease","-moz-transition":"all 0.0s ease","-o-transition":"all 0.0s ease","transition":"all 0.0s ease"});
            //     $(".loginbg").show();
            // }
        },
        methods: {
            setCookie: function (cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },
            getCookie: function (cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            autoLoginUser: function (username) {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    'username': username,
                    'access_token': window.localStorage.getItem('api_token')
                };
                HTTP.post("autologinuser", fields)
                    .then(function (data) {
                        if (data.status == 200) {
                            console.log(JSON.stringify(data));
                            /* Build version checking start*/
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.data.content.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.data.content.build);
                            } else if(current_build != latest_build){
                                localStorage.setItem("build_version", data.data.content.build);
                                console.info("New Build Version " + latest_build);
                                location.reload(true);
                            }
                            /* Build version checking end*/
                            localStorage.setItem("user_obj", JSON.stringify(data.data.content.user));
                            localStorage.setItem("api_token", data.data.content.api_token);
                            // console.log(data.data.content.roles.roles.id)
                            localStorage.setItem("roleId", JSON.stringify(data.data.content.roles.roles.system_id));
                            localStorage.setItem("app_year", (data.data.app_year));
                            localStorage.setItem("menu_small", '1');
                            window.location.href = "/listcustomer";
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        if(error.response.data.code == 401) {
                            window.location.href = process.env.SSO_ROOT_URL + "/login?redirect=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                        }
                        self.login_err_msg = error.response.data.message;
                    })
            },
            attemptLogin() {
                this.$validator.validate().then(result => {
                    if (result) {
                        //console.log('LoginForm');
                        var app = this;
                        $('#errorMsg').hide();
                        app.fronterrors = [];
                        $.ajax({
                            url: process.env.ROOT_API + "/login",
                            type: "POST",
                            crossDomain: true,
                            data: app.loginFormData,
                            success: function (data) {
                                //console.log(data.content);
                                if (data.status == "success") {
                                    $('.navbar').show();
                                    //self.timezones = data.content;
                                    window.localStorage.setItem("api_token", data.content.api_token);
                                    window.localStorage.setItem("user_obj", JSON.stringify(data.content.user_obj));
                                    window.localStorage.setItem("menu_small", '1');
                                    window.localStorage.setItem("app_year", data.content.app_year);
                                    /*app.$router.push("/");*/

                                    EventBus.$emit('logged-in', false, data.content.user_obj["first_name"], data.content.user_obj["last_name"], data.content.user_obj["email"]);


                                    app.$router.push("/listcustomer");
                                }
                                if (data.code == 201) {
                                    if (data.content.username[0]) {
                                        app.fronterrors.push(data.content.username[0]);
                                    }
                                    if (data.content.password[0]) {
                                        app.fronterrors.push(data.content.password[0]);
                                    }


                                }
                            },
                            error: function (jqXHR, exception) {
                                self.Registerbtn = "Register";
                                if (jqXHR.status == 0) {
                                    self.registerError = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').show();
                                    $('#errorMsg').html(jqXHR.responseJSON.message);
                                }
                            }
                        });
                        //
                    }
                });
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/StaffLogin.vue